








































































































































































import { Component, Vue, Watch } from "vue-property-decorator";
import Native from "@/common/Native";
import request from "@/api/yunyang/index";
import AppPrompt from "@/components/AppPrompt.vue";
import indexRequest from "@/api/index";
import { IuserInfo, ITopicDetail, ITopicListRes } from "@/api/yunyang/types";
import { Base64 } from "js-base64";
import Base from "@/template/public/Base.vue";
import { wxChatShare } from "@/common/wechat";
import {
  Image as vanImage,
  Lazyload,
  DropdownMenu as vanDropdownMenu,
  DropdownItem as vanDropdownItem,
  PullRefresh as vanPullRefresh,
  List as vanList,
  Dialog
} from "vant";
interface INav {
  name: string;
  id: number;
}
Vue.use(Lazyload, {});
@Component({
  components: {
    vanImage,
    vanDropdownMenu,
    vanDropdownItem,
    vanPullRefresh,
    vanList,
    AppPrompt
  }
})
export default class saledetail extends Base {
  isOpenMore: boolean = false;
  isOpenInApp: boolean = false;
  id: string = "";
  appId: string = "";
  userInfo: IuserInfo = { phone: "", sessionId: "", token: "" };
  detail: ITopicDetail = {};
  currentNav: number = 0;
  list: Array<ITopicDetail> = [];
  newsLoaded: boolean = false;
  listLoading: boolean = false;
  isLoading: boolean = false;
  finished: boolean = false;
  public request: any = new indexRequest();
  navList: Array<INav> = [
    {
      name: "最新",
      id: 1
    },
    {
      name: "热门",
      id: 2
    }
  ];
  mounted() {
    this.appId = (this.$route.query.appId as string) || "";
    this.isOpenInApp = ZWY_CLOUD.isOpenInApp();
    this.id = (this.$route.query.id as string) || "";
    this.getShareInfo(this.appId);
    this.getSquareDetail();
    this.getList();
  }
  toDetail(id: string) {
    const url =
      window.location.href.split("#")[0] +
      "#/topic/topic?&app_id=" +
      this.appId +
      "&id=" +
      id;
    this.switchUrl(url);
  }
  switchUrl(url: string) {
    if (this.isOpenInApp) {
      ZWY_CLOUD.redirectUrl({
        id: "",
        sourceId: "",
        sourceType: "8",
        detailViewType: "98",
        commentType: "0",
        isShowBottom: "0",
        isShowMore: "0",
        isShowTop: "1",
        shareImgUrl: "",
        shareUrl: window.location.href,
        synopsis: Base64.encode(""),
        title: Base64.encode(""),
        url: encodeURI(url),
        contextType: "1"
      });
    } else {
      window.open(url);
    }
  }
  switchNav(i: number) {
    this.currentNav = i;
    this.getList(true);
  }
  getSquareDetail() {
    let data = {
      id: this.id,
      appId: this.appId,
      sessionId: this.userInfo.sessionId,
      token: this.userInfo.token,
      isOpenApp: ""
    };
    request.squareShareDetail(data).then((res: any) => {
      if (res.code >= 0) {
        this.detail = res.data;
        wxChatShare(
          this.detail.name,
          this.detail.description,
          window.location.href,
          this.detail.icon
        );
      }
    });
  }
  onRefresh() {
    this.getList(true).then(() => {
      this.isLoading = false;
      this.$toast("刷新成功");
    });
  }
  onListLoad() {
    if (this.list.length == 0) {
      return;
    }
    this.getList(false);
  }
  getList(isClear: boolean = true) {
    let _this = this;

    let lastId = "",
      sortNoValue = "",
      lastBusinessValue = "",
      lastReplyCountValue = "";
    if (this.list.length > 0 && !isClear) {
      let lastItem = this.list[this.list.length - 1];
      lastId = String(lastItem["id"]);
      sortNoValue = String(lastItem["sortNo"]);
      lastBusinessValue = String(lastItem["sortNo"]);
      lastReplyCountValue = String(lastItem["replyCount"]);
    }

    return request
      .getMoments({
        token: "",
        sessionId: "",
        appId: this.appId,
        lastId: lastId,
        topicId: this.id,
        lastBusinessValue: "",
        lastReplyCountValue: lastReplyCountValue,
        userId: "",
        listType: this.currentNav == 0 ? "t-n" : "t-h",
        search: "",
        isFengJie: "",
        categoryCode: ""
      })
      .then((res: ITopicListRes) => {
        if (res.code >= 0) {
          res.data.dataList = res.data.dataList ? res.data.dataList : [];
          if (res.data.dataList.length == 0) {
            _this.finished = true;
          } else {
            _this.finished = false;
          }
          if (isClear) {
            _this.list = res.data.dataList;
          } else {
            _this.list = _this.list.concat(res.data.dataList);
          }
          _this.listLoading = false;
        }
      });
  }

  doSome(item: any) {
    Dialog.alert({
      message: "请前往下载" + this.shareInfo.appName + "客户端！",
      closeOnClickOverlay: true
    }).then(() => {
      // on close
      // obj.jumpToApp(this.shareJson.downloadUrl, this.shareJson);
      // window.location.href = this.downloadUrl;
      this.openApp(item);
    });
  }
  removeCharacter(str: string | undefined) {
    return str ? str.replace(/#/g, "") : "";
  }
}
